import firebase from 'firebase';
import { BILL_STATUS } from '../../constants/data';
import { BillModel } from '../../models/bill';

export const serializeBillSnap = (bill: firebase.firestore.DocumentSnapshot): BillModel => {
  return serializeBill(bill.id, bill.data() ?? {});
};

export const serializeBill = (id: string, data: {[key: string]: any}): BillModel => ({
  id: id,
  amount: data.amount ?? 0,
  status: data.status ?? BILL_STATUS.unpaid,
  walletAmount: data.walletAmount ?? 0,
});
